import EventEmitter from "events";

import AuthApi from "../api/auth";

const loginEvent = "loginEvent";
const env = process.env.NODE_ENV;
const cookieSecure = process.env.VUE_APP_COOKIE_SECURE == "true" ? true : null;
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
const tokenKey = process.env.VUE_APP_COOKIE_AUTH;
const tokenExpiryKey = process.env.VUE_APP_COOKIE_AUTH_TE;
const tokenUserInfo = process.env.VUE_APP_COOKIE_AUTH_UI;

class AuthService extends EventEmitter {
  profile = null;
  tokenExpiry = null;

  async login(body, customState) {
    let response = await AuthApi.login(body, customState);

    if (!response.data.error) {
      this.setLogin(response.data);
    }
  }

  localLogin(authResult) {
    this.profile = authResult;
    var token = this.profile.Token;
    this.tokenExpiry = authResult.TokenExpire;
    $cookies.set(
      tokenExpiryKey,
      this.tokenExpiry,
      "1h",
      null,
      cookieDomain,
      cookieSecure
    );
    $cookies.set(
      tokenUserInfo,
      this.profile,
      "1h",
      null,
      cookieDomain,
      cookieSecure
    );

    $cookies.set(
      tokenKey,
      token,
      "1h",
      null,
      cookieDomain,
      cookieSecure
    );
    this.emit(loginEvent, {
      loggedIn: true,
      profile: this.profile
    });
  }

  setLogin(authResult) {
    this.profile = authResult;
    var token = this.profile.Token;

    this.tokenExpiry = authResult.TokenExpire;
    $cookies.set(
      tokenExpiryKey,
      this.tokenExpiry,
      "7d",
      null,
      cookieDomain,
      cookieSecure
    );
    $cookies.set(
      tokenUserInfo,
      this.profile,
      "7d",
      null,
      cookieDomain,
      cookieSecure
    );

    $cookies.set(
      tokenKey,
      token,
      "7d",
      null,
      cookieDomain,
      cookieSecure
    );

    this.emit(loginEvent, {
      loggedIn: true,
      profile: this.profile
    });
  }

  renewTokens() {
    if (this.isAuthenticated()) {
      this.emit(loginEvent, {
        loggedIn: true,
        profile: $cookies.get(tokenUserInfo)
      });
    }
  }

  logOut() {
    $cookies.remove(tokenKey, "/", cookieDomain);
    $cookies.remove(tokenExpiryKey, "/", cookieDomain);
    $cookies.remove(tokenUserInfo, "/", cookieDomain);

    this.tokenExpiry = null;
    this.profile = null;

    this.emit(loginEvent, { loggedIn: false });
  }

  isAuthenticated() {
    return (
      $cookies.get(tokenKey)
    );
  }

  hasUserRole(role) {
    if (role == "*") return true;
    if (role == '~') return this.isAuthenticated();

    const localData = $cookies.get(tokenUserInfo);
    if (!localData) return false;

    const userInfo = $cookies.get(tokenUserInfo);
    return userInfo &&
      userInfo.Roles &&
      userInfo.Roles.some(x => x.includes(role))
      ? true
      : false;
  }

  can(controller, method, level) {
    let canAccess = false;
    const localData = $cookies.get(tokenUserInfo);

    if (localData && this.isAuthenticated()) {
      const userInfo = $cookies.get(tokenUserInfo);
      if (userInfo.Roles && userInfo.Roles.length >= 0) {
        userInfo.Roles.forEach(el => {
          const spArray = el.toString().split(".");
          if (spArray.length >= 3) {
            const _controller = spArray[spArray.length - 3];
            const _method = spArray[spArray.length - 2];
            const _level = spArray[spArray.length - 1];

            if (
              controller.toLowerCase() == _controller.toLowerCase() &&
              method.toLowerCase() == _method.toLowerCase() &&
              level.toLowerCase() == _level.toLowerCase()
            )
              return (canAccess = true);
          }
        });
      }
    }
    return canAccess;
  }
}

export default new AuthService();
